import * as Raven from "raven-js";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";
import { AgmCoreModule } from "@agm/core";
import { LightboxModule } from "ngx-lightbox";
import {
  ApiModule,
  BASE_PATH,
  AccountService,
  NotificationService,
  ServiceProviderCaseService,
  AuthService,
  DeadlineService,
} from "./modules/api";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LazyLoadImagesModule } from "ngx-lazy-load-images";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpsInterceptor } from "./shared/service/https-interceptor";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppComponent } from "./app.component";
import { AppRoutesModule } from "./app-routes.module";
import { ToastService } from "./shared/service/toast.service";
import { DataService } from "./shared/service/data.service";
import {
  ConfirmService,
  ConfirmComponent,
} from "./shared/service/confirm.service";
import { LoaderService } from "./shared/service/loader.service";
import { CustomerFormComponent } from "./modules/customers/components/customer-form/customer-form.component";
import { CaseComponent } from "./modules/customers/components/case/case.component";
import { PasswordComponent } from "./modules/settings/components/password/password.component";

import { MessagingService } from "./shared/service/messaging.service";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireModule } from "angularfire2";
import { MomentModule } from "ngx-moment";
import { NgbDateFormatter } from "../../libs/ngb-date-formatter";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { FormComponent } from "./modules/cases/components/form/form.component";
import { ReceiveComponent } from "./modules/cases/components/receive/receive.component";
import { OrderComponent } from "./modules/cases/components/order/order.component";
import { ReturnComponent } from "./modules/cases/components/return/return.component";
import { BikeComponent } from "./modules/customers/components/bike/bike.component";
import { BikeViewComponent } from "./modules/customers/components/bike-view/bike-view.component";
import { MyCaseComponent } from "./modules/myCases/components/case/myCase.component";
import { MyBikeComponent } from "./modules/myBikes/components/bike/myBike.component";
import { ContactLogComponent } from "./modules/cases/components/contact-log/contact-log.component";
import { SharedModule } from "./shared/modules/shared.module.ts";


// export class ToastOption extends ToastOptions {
//   animate = 'fade';
//   positionClass = 'toast-top-center';
//   maxShown = 1;
//   showCloseButton = true;
//   // toastLife = 1000000;
// }

// if (environment.production) {
//   Raven.config(
//     "https://c446aca0475c4abc8df5e155778752a7@sentry.titanplan.info/5"
//   ).install();
// }
export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Raven.captureException(err);
  }
}
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    environment.API_BASE_PATH + "/api/languages/",
    "?ver=1"
  );
}

@NgModule({
  declarations: [
    AppComponent,
    ConfirmComponent,
    CustomerFormComponent,
    CaseComponent,
    MyCaseComponent,
    MyBikeComponent,
    PasswordComponent,
    FormComponent,
    ReceiveComponent,
    OrderComponent,
    BikeComponent,
    ReturnComponent,
    BikeViewComponent,
    ContactLogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutesModule,
    HttpClientModule,
    NgSelectModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      closeButton: false,
      positionClass: "toast-top-center",
      preventDuplicates: true,
    }),
    NgbModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_API,
      libraries: ["places"],
    }),
    LightboxModule,
    ReactiveFormsModule,
    FormsModule,
    LazyLoadImagesModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MomentModule,
    SharedModule

  ],
  providers: [
    ToastService,
    ConfirmService,
    DataService,
    LoaderService,
    MessagingService,
    { provide: NgbDateParserFormatter, useClass: NgbDateFormatter },
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: HTTP_INTERCEPTORS, useClass: HttpsInterceptor, multi: true },
    AccountService,
    NotificationService,
    ServiceProviderCaseService,
    AuthService,
    DeadlineService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmComponent,
    CustomerFormComponent,
    CaseComponent,
    MyCaseComponent,
    MyBikeComponent,
    PasswordComponent,
    FormComponent,
    OrderComponent,
    ReceiveComponent,
    ReturnComponent,
    BikeComponent,
    BikeViewComponent,
    ContactLogComponent,
  ],
})
export class AppModule {}
